module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    staticStyle: {
      "overflow": "hidden",
      "height": "100vh",
      "width": "100%"
    },
    attrs: {
      "src": "//getakko.com/app-faqs",
      "frameborder": "0",
      "height": "100vh",
      "width": "100%",
      "title": "Frequently Asked Questions"
    }
  }, [_vm._v("\n  Your browser does not support iFrames.\n")])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a2f43fc2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2f43fc2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Faq.vue
// module id = 455
// module chunks = 0